export enum IApiRoutes {
  Bio = 'bio',
  Contacts = 'contacts',
  Experience = 'experience',
  Education = 'education',
  Languages = 'languages',
  Projects = 'projects',
  Skills = 'skills',
}
